import { API_URLs } from "../../../../utilities/API_URLs";
import iAxios from "../../../../utilities/axios/axios-setup";
import { LoginRequestType } from "./_model";

export const doLogin = (payload: LoginRequestType) => {
  return iAxios
    .post(API_URLs.auth.postLogin, payload)
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return e;
    });
};
